import { noteToMidi } from "../../../common/utils";
import generateNumberArray from "../../../common/utils/generateNumberArray";

export const DEFAULT_MIN_NOTE = "C2";
export const DEFAULT_MAX_NOTE = "C7";

export const NOTE_OPTIONS = generateNumberArray(noteToMidi(DEFAULT_MIN_NOTE), noteToMidi(DEFAULT_MAX_NOTE), true);
